import i18next from "i18next";
import type { HostProvidedKey } from "../contract/types";
import { TranslationKey } from "../translations/keys";

export type TranslateArguments = {
  key: TranslationKey;
  interpolationValues?: {
    [key: string]: string | number;
  };
};

export const i18n = ({ key, interpolationValues = {} }: TranslateArguments): string =>
  i18next.t(key, interpolationValues);

export const asHostProvidedKey = (key: string): HostProvidedKey => key as HostProvidedKey;
